<!--
파일 리스트 (업로드기능 없이, 리스팅만함)
-->
<template>
    <div v-show="items.length > 0" class="">
        <h5 class="uk-text-muted" v-if="! hideHeader">
            <i class="material-icons uk-text-middle">
                attachment
            </i>
            <span class="uk-text-middle">{{ headerText }}</span>
        </h5>

        <!-- 업로드된 파일 리스트 -->
        <div  class="uploaded-items uk-flex uk-flex-left uk-flex-wrap">
            <div v-for="item in items" :key="item.id" class="uploaded-item">
                <!-- 썸네일 -->
                <div class="thumb">
                    <!-- 이미지 -->
                    <img 
                        v-if="item.is_img === 1"
                        :src="item.url" 
                        class="img-file"
                    />

                    <!-- 기타파일 -->
                    <i v-if="item.is_img !== 1" class="material-icons etc-file">
                        attach_file
                    </i>
                </div>

                <!-- 파일정보 -->
                <div class="file-info">
                    <div class="size" :title="item.size">
                        {{ item.size }}
                    </div>
                    <div class="uploaded_by" :title="item.uploaded_by_nick">
                        by {{ item.uploaded_by_nick }}
                    </div>
                    <div class="created_at" :title="item.created_at">
                        at {{ item.created_at }}
                    </div>
                </div>

                <!-- 파일명 -->
                <div class="file-name" :title="item.name">
                    {{ item.name }}
                </div>


                <!-- 바로보기 버튼 -->
                <a 
                    class="view-btn" 
                    :href="item.url" 
                    title="click to view" 
                    target="_blank"
                >
                    <i class="material-icons">pageview</i>
                </a>

                <!-- 다운 버튼 -->
                <a 
                    class="down-btn" 
                    :href="item.download_url" 
                    title="click to download" 
                    target="_blank"
                >
                    <i class="material-icons">cloud_download</i>
                </a>
                
            </div>
        </div>
        
        
    </div>

</template>

<script>
    // vue component
    export default {
        props: {
            /**
             * 라라벨 csrf 토큰
             */
            csrfToken: {
                type: String,
                default: null
            },
            /**
             * 파일종류
             */
            type: {
                type: Number,
                default: null
            },
            /**
             * 임시 ID
             */
            tempId: {
                type: Number,
                default: null
            },
            /**
             * 커뮤니케이션 ID
             */
            cmId: {
                type: Number,
                default: null
            },
            /**
             * 상품ID
             */
            prodId: {
                type: Number,
                default: null
            },
            /**
             * 사용자ID
             */
            userId: {
                type: Number,
                default: null
            },
            /**
             * 특정 커뮤니케이션 ID 제외하고 검색
             */
            withoutCmId: {
                type: Number,
                default: null
            },
            /**
             * 컴포넌트 헤더
             */
            headerText: {
                type: String,
                default: 'ATTACHMENTS (첨부파일)'
            },
            /**
             * 헤더 표시여부
             */
            hideHeader: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
                /**
                 * 업로드가 완료된 파일 배열
                 * [
                 *      {}, 서버에서 받아온 업로드된 파일정보
                 *      .
                 *      .
                 *      .
                 *      {
                 *          App\Http\Controllers\Web\Files\Store 참고
                 *      }
                 * ]
                 */
                items: [],
            };
        },
        computed: {
        },
        watch: {
        },
        mounted: function () {
            let cmp = this;

            this.refreshList();
            

            
        },
        methods: {

            /**
             * 파일리스트 ajax load
             */
            refreshList: function () {

                let cmp = this;


                // ajax 옵션
                let opts = {
                    type: 'get',
                    url: '/files',
                    data: {
                        'temp_id': cmp.tempId,
                        'cm_id': cmp.cmId,
                        'prod_id': cmp.prodId,
                        'user_id': cmp.userId,
                        'without_cm_id': cmp.withoutCmId,
                    },
                    success: function (res) {
                        // 초기화
                        cmp.items = [];

                        _.forEach(res.uploaded_files, function (uploaded) {
                            cmp.items.push(uploaded);
                        });

                    }
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        }
    }
</script>

<style lang="scss" scoped>
    // 리스트 영역
    .uploaded-items{
        padding: 20px;
        background-color: #fff;
        border: 1px solid #999;
    }

    // 업로드 아이템
    .uploaded-item {
        width: 9rem;
        //margin-right: 1.5rem;
        margin: 1.5rem;
        text-align: center;
        position: relative;

        // 파일 썸네일
        .thumb {
            // 이미지
            .img-file {
                object-fit: contain;
                width: 8rem;
                height: 8rem;
            }
            // 기타파일
            .etc-file {
                font-size: 8rem;
            }
        }

        // 파일정보
        .file-info {
            opacity: 0;
            position: absolute;
            top: 0.75rem;
            left: 0;
            width: 9rem;
            height: 7rem;
            background-color: #000;
            color: #eaeaea;

            .size, .uploaded_by, .created_at {
                padding: 3px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        // 파일명
        .file-name {

            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

        }


        // 삭제
        .remove-btn {
            opacity: 0;
            position: absolute;
            top: -1rem;
            right: -1rem;
            z-index: 30;

            i.material-icons {
                cursor: pointer;
                font-size: 2rem;
                color: #999;
            }

            &:hover {
                i.material-icons {
                    //font-size: 2rem;
                    color: #f0506e;
                }
            }
        }

        // 바로보기
        .view-btn {
            opacity: 0;
            position: absolute;
            bottom: -2.25rem;
            left: 1rem;
            z-index: 30;

            i.material-icons {
                font-size: 2rem;
                cursor: pointer;
                color: #333;
            }

            &:hover {
                i.material-icons {
                    color: #1e87f0;
                }
            }
        }

        // 다운
        .down-btn {
            opacity: 0;
            position: absolute;
            bottom: -2.25rem;
            right: 1rem;
            z-index: 30;

            i.material-icons {
                font-size: 2rem;
                cursor: pointer;
                color: #333;
            }

            &:hover {
                i.material-icons {
                    color: #1e87f0;
                }
            }
        }

        // 마우스오버
        &:hover {
            .file-info {
                opacity: 0.8;
            }
            .remove-btn {
                opacity: 1;
            }
            .view-btn {
                opacity: 1;
            }
            .down-btn {
                opacity: 1;
            }
        }


    }
</style>